/**
 * 完結したHTML文書を新規タブに開き、印刷（PDF保存）ダイアログを出す。
 *
 * Shopify 埋め込みアプリ（App Bridge の iframe 内）では、隠し iframe の
 * `contentWindow.print()` が管理画面側の印刷に乗っ取られ、発注書ではなく
 * 空白の管理画面が印刷されてしまう。そのため Blob URL を実タブとして開き、
 * その中で印刷する。日本語もブラウザ標準フォントで正しく描画され、管理画面の
 * chrome（URL バーやアプリ枠）も混入しない。
 */

import { t } from "../lib/i18n";

export function printHtmlDocument(html: string): void {
  const blob = new Blob([injectAutoPrint(html)], { type: "text/html" });
  const url = URL.createObjectURL(blob);

  const win = window.open(url, "_blank");
  if (win === null) {
    // ポップアップがブロックされた場合は HTML をダウンロードさせ、手動印刷に委ねる。
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = t("発注書.html");
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  } else {
    win.focus();
  }

  // 新規タブがロードし終える猶予を持って object URL を解放する。
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

/**
 * `</body>` 直前に、読込完了後 window.print() を呼ぶスクリプトを挿入する
 * （body が無ければ末尾に付与）。新規タブが開いた瞬間に印刷ダイアログが出る。
 */
export function injectAutoPrint(html: string): string {
  const script =
    '<script>window.addEventListener("load",function(){' +
    "setTimeout(function(){window.focus();window.print();},150);});<\/script>";
  const idx = html.toLowerCase().lastIndexOf("</body>");
  if (idx === -1) return html + script;
  return html.slice(0, idx) + script + html.slice(idx);
}
